import React, { useEffect } from "react";

import "./Services.css";

/* IMPORT HEADER */

import Header from "../Header/Header";

/* IMPORT IMAGES */



import service1 from "../../uploads/fidin img pdf_page-0011.jpg";

import service2 from "../../uploads/fidin img pdf_page-0012.jpg";

import service3 from "../../uploads/fidin img pdf_page-0013.jpg";

const Services = () => {

  useEffect(() => {

    const observer = new IntersectionObserver(

      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.style.opacity = "1";

            entry.target.style.transform = "translateY(0px)";
          }
        });
      },

      {
        threshold: 0.1,
      }
    );

    const boxes = document.querySelectorAll(".service-box");

    boxes.forEach((box) => {

      box.style.opacity = "0";

      box.style.transform = "translateY(40px)";

      box.style.transition = "all 1s ease";

      observer.observe(box);
    });

    return () => observer.disconnect();

  }, []);

  return (

    <div className="services-page">

      {/* HEADER */}

      <Header />

      {/* HERO */}

<section className="services-hero">

  <h1>
    Our Services
  </h1>

  <p>
    End-to-End Solutions for Energy & Infrastructure
  </p>

</section>

      {/* MAIN */}

      <div className="services-container">


        {/* SERVICE 1 */}

        <div className="service-box">

          <h2>
            Renewable Energy Solutions
          </h2>

          <img
            src={service1}
            alt="Solar Power"
            className="service-img"
          />

          <p>
            We develop and execute solar power projects designed for
            long-term performance.
          </p>

          <h4>
            Services include:
          </h4>

          <ul>

            <li>Site assessment & feasibility</li>

            <li>Design & engineering</li>

            <li>Procurement & installation</li>

            <li>Testing & commissioning</li>

          </ul>

        </div>

        {/* SERVICE 2 */}

        <div className="service-box">

          <h2>
            Transmission & Distribution
          </h2>

          <img
            src={service2}
            alt="Transmission Lines"
            className="service-img"
          />

          <p>
            Execution of transmission lines and substations with full
            compliance.
          </p>

          <h4>
            Scope:
          </h4>

          <ul>

            <li>33kV to 220kV transmission lines</li>

            <li>Substations & switchyards</li>

            <li>Power evacuation systems</li>

          </ul>

        </div>

        {/* SERVICE 3 */}

        <div className="service-box">

          <h2>
            EPC Services
          </h2>

          <img
            src={service3}
            alt="EPC Services"
            className="service-img"
          />

          <p>
            End-to-end project execution from concept to commissioning.
          </p>

          <h4>
            Includes:
          </h4>

          <ul>

            <li>Engineering</li>

            <li>Procurement</li>

            <li>Construction</li>

            <li>Project management</li>

          </ul>

        </div>

      </div>

      {/* FOOTER */}

      <footer className="services-footer">

        <p>
          © 2026 FIDIN Ventures. All Rights Reserved.
        </p>

      </footer>

    </div>
  );
};

export default Services;